import * as yup from "yup";
import moment from "moment";
import { PUBLIC_API_KEY_NAME_MAX_LENGTH } from "services/api/settings/publicApi/consts";

/** Shema ovisi o „sada” — istek mora biti barem sutra, pa se gradi pri otvaranju prozora. */
export const createPublicApiKeyValidationSchema = (now: Date) => {
  const startOfTomorrow = moment(now).add(1, "day").startOf("day").toDate();

  return yup.object().shape({
    name: yup
      .string()
      .trim()
      .required("Unesite naziv ključa, npr. „Web stranica”.")
      .max(
        PUBLIC_API_KEY_NAME_MAX_LENGTH,
        `Naziv može imati najviše ${PUBLIC_API_KEY_NAME_MAX_LENGTH} znakova.`
      ),
    expiresAt: yup
      .date()
      .nullable()
      .min(startOfTomorrow, "Datum isteka mora biti u budućnosti."),
  });
};
